import * as React from 'react';
import { PhotoCard } from '@riac/design-system';
import dayjs from 'dayjs';

type TNewsCardProps = {
  post: {
    title: string,
    navigation: string,
    date: dayjs.ConfigType,
    content: string,
    image: string,
    tags: string[],
  },
  pageChanging: boolean,
}

export const NewsCard = ({ post, pageChanging }: TNewsCardProps) => {
  return (
    <PhotoCard
      title={post.title}
      to={post.navigation}
      text={post.content}
      footerText={dayjs(post.date).format('MMMM D, YYYY')} // post.date is in UTC and displayed in local time
      image={post.image}
      tags={post.tags.includes('events') ? [{ text: 'Event', status: 'warning' }] : post.tags.includes('blogs') ? [{ text: 'Blog', status: 'success' }] : post.tags.includes('news') ? [{ text: 'News', status: 'primary' }] : post.tags.includes('videos') ? [{ text: 'Video', status: 'error' }] : []}
      className={pageChanging && 'blur-xs opacity-25'}
      imgClassName={pageChanging && 'saturate-0'}
      aspectClassName='aspect-video'
      titleClassName='min-h-16'
      textClassName='min-h-12'
    />
  );
};
